import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  CircularLoadingButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

type PublishProps = {
  isLoading: boolean;
  onCloseDialog: () => void;
  onPublish: () => void;
  isBulk?: boolean;
};

const Publish = ({
  isLoading,
  onCloseDialog,
  onPublish,
  isBulk = false,
}: PublishProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <Dialog open modal>
      <DialogOverlay />
      <DialogRoot size={'s'}>
        <DialogHeader onClose={onCloseDialog}>
          <DialogTitle>
            {isBulk
              ? t('Publish selected suggestions?')
              : t('Publish this suggestion?')}
          </DialogTitle>
        </DialogHeader>
        <DialogContent className="flex flex-col">
          <p className={typographyVariants({ variant: 'bodyShort01' })}>
            {isBulk
              ? t('If you proceed the selected suggestions will be published')
              : t('If you proceed this suggestion will be published')}
          </p>
        </DialogContent>
        <DialogFooter className="flex flex-row gap-2">
          <Button
            onClick={onPublish}
            variant="contained"
            size="large"
            disabled={isLoading}
          >
            {isLoading && (
              <CircularLoadingButton size="small" variant="contained" />
            )}
            {t('Yes, publish')}
          </Button>
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};

export default Publish;
